module.exports = "/_next/static/images/signature-34df42bd121ce310f482e761ae8e7abc.svg";